import curd from '../curd'

const BASE_PATH = '/no/data/record'

export default curd(BASE_PATH, {
  getNoData: (auditTime, siteDeviceId) => ({
    url: `${BASE_PATH}/get/list?auditTime=${auditTime}&siteDeviceId=${siteDeviceId}`,
    method: 'GET'
  }),
  saveNoData: data => ({
    url: `${BASE_PATH}/insert/or/update`,
    method: 'POST',
    data: data
  }),
  getNoDataListBySite: query => ({
    url: `${BASE_PATH}/get/list/site`,
    method: 'POST',
    data: {
      beginTime: query.beginTime,
      endTime: query.endTime,
      ids: query.siteIds
    }
  }),
  getNoDataListByDevice: query => ({
    url: `${BASE_PATH}/get/list/device`,
    method: 'POST',
    data: {
      beginTime: query.beginTime,
      endTime: query.endTime,
      ids: query.siteIds
    }
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/NoData.js